import { useTranslator } from '@gandi/translate';
function extractBankValues(bu) {
  return {
    buName: bu.address.name || bu.name,
    bankName: bu.bank.name,
    bankStreet: bu.bank.address.street,
    bankZipAndCity: bu.bank.address.zip ? `${bu.bank.address.zip} ${bu.bank.address.city}` : bu.bank.address.city,
    bankCountry: bu.bank.address.country_name,
    bankAccount: bu.bank.account || '-',
    bankIBAN: bu.bank.iban || '-',
    bankBIC: bu.bank.bic || '-',
    bankEmail: bu.email,
    bankFax: bu.fax
  };
}
function getTransferInfos(bu, __, orderId) {
  if (!bu.bank) {
    return [];
  }
  const bankValues = extractBankValues(bu);
  return [{
    label: __('Bank Address'),
    values: [bankValues.bankName, bankValues.bankStreet, bankValues.bankZipAndCity, bankValues.bankCountry]
  }, {
    label: __('Account holder'),
    values: [bankValues.buName, bankValues.bankAccount]
  }, {
    label: __('IBAN'),
    values: [bankValues.bankIBAN]
  }, {
    label: __('BIC'),
    values: [bankValues.bankBIC]
  }, {
    label: __('Comment field'),
    values: [__('Order %(id)s', {
      id: orderId
    })]
  }];
}
function getCheckInfos(bu) {
  return [{
    values: [bu.address.name || bu.name, bu.address.street, bu.address.street2 || '', `${bu.address.zip || ''} ${bu.address.city || ''}`, bu.address.country_name]
  }];
}
function getMandateInfos(bu, __, orderId) {
  return [{
    label: __('Email'),
    values: [bu.email]
  }, {
    label: __('Mail'),
    values: [bu.address.name || bu.name, bu.address.street, bu.address.street2 || '', `${bu.address.zip || ''} ${bu.address.city || ''}`, bu.address.country_name]
  }, {
    label: __('Fax'),
    values: [bu.fax]
  }, {
    label: __('Comment field'),
    values: [__('Order %(id)s', {
      id: orderId
    })]
  }];
}
export function usePaymentTypeTranslation({
  payment_type,
  bu,
  id
}) {
  const {
    __
  } = useTranslator();
  switch (payment_type) {
    case 'transfer':
      return {
        title: __('Where to address your bank transfer.'),
        content: getTransferInfos(bu, __, id)
      };
    case 'check':
      return {
        title: __('Where to send your check purchase.'),
        content: getCheckInfos(bu)
      };
    case 'mandate':
      return {
        title: __('Where to send your purchase order.'),
        content: getMandateInfos(bu, __, id)
      };
    default:
      return undefined;
  }
}
export function useTitle(order) {
  const {
    __
  } = useTranslator();
  if (order.payment_type === 'check') return __('Send your check to the following address with your order number written on the back.');
  if (order.payment_type === 'mandate') return __('Print the proforma and sign it to make a purchase order. ' + 'You can send it by email, mail or fax. After our validation you may ' + 'proceed to the payment. if you want to use your own purchase order, ' + 'precise the order number **%(transaction)s** & the amount **%(amount)s**', {
    withMarkdown: true,
    amount: order.price_after_taxes_label,
    transaction: order.id
  });
  return __('Specify the order number in the transfer’s comment field.');
}